import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../contexts/kato.context';
import { useShared } from '../../../contexts/shared.context';
import FooterComponent from '../components/footer.component';
import Field from '../../../components/field/field.component';
import { toast } from 'react-toastify';
import { t } from '../../../helpers/utils';
import { GeneralInfoStatus } from '../../../types/kato.types';
import { updateAutoLinkData } from '../../../requests/supervisor.request';
import classes from './styles.module.scss';

const baseClass = 'tax-tab';
const translationKey = 'admin.tax';

const BudgetInvestmentTab = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const { katoGeneralInfo, updatedGeneralInfo } = useKato();
  const { budgetInvIframe, status } = katoGeneralInfo || {};
  const { selectedInfoYear } = useShared();

  const [formData, setFormData] = useState({
    status: status || GeneralInfoStatus.IN_PROCESS,
  });

  const [autolinkCard, setAutolinkCard] = useState<string>('');
  const [autolinkFullScreen, setAutolinkFullScreen] = useState<string>('');

  const [errors, setErrors] = useState<Record<string, boolean>>({});

  const validateFields = () => {
    const newErrors: Record<string, boolean> = {};

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => !error);
  };
  const handleSave = () => {
    const data = {
      budgetInvIframe: {
        iframeUrlExp: autolinkCard,
        iframeUrlAltExp: autolinkFullScreen,
        kato: katoGeneralInfo.kato,
      },
      status: formData.status,
    };
    updateAutoLinkData(katoGeneralInfo.kato, data, selectedInfoYear).then(
      () => {
        updatedGeneralInfo(selectedInfoYear);
        toast.success(t(`admin.success`, language));
      },
    );
  };

  useEffect(() => {
    setFormData({
      status: status || GeneralInfoStatus.IN_PROCESS,
    });
  }, [katoGeneralInfo.kato, selectedInfoYear]);

  useEffect(() => {
    budgetInvIframe?.iframeUrlExp &&
      setAutolinkCard(budgetInvIframe?.iframeUrlExp);
    budgetInvIframe?.iframeUrlAltExp &&
      setAutolinkFullScreen(budgetInvIframe?.iframeUrlAltExp);
  }, [budgetInvIframe]);

  return (
    <div className={classes[baseClass]}>
      <div className={classes[`fields-container`]}>
        <Field
          value={autolinkCard}
          type="text"
          label={t(`${translationKey}.autolink_card`)}
          onChange={(value) => setAutolinkCard(value as string)}
          required
        />
        <Field
          value={autolinkFullScreen}
          type="text"
          label={t(`${translationKey}.autolink_fullscreen`)}
          onChange={(value) => setAutolinkFullScreen(value as string)}
          required
        />
      </div>

      <FooterComponent
        onSave={handleSave}
        status={formData.status}
        validateFields={validateFields}
      />
    </div>
  );
};

export default BudgetInvestmentTab;
